module.exports = __webpack_public_path__ + "img/Sign-up-Ar.10a7a8f7.svg";